import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useLanguage } from "../context/LanguageContext";
import { useT } from "../i18n";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Blog = () => {
  const { lang } = useLanguage();
  const t = useT(lang);
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blog`).then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <div className="py-24 md:py-32">
      <div className="container-wc">
        <div className="max-w-3xl mb-16 fade-up">
          <div className="flex items-center gap-3 mb-4">
            <span className="divider-gold" />
            <span className="eyebrow">{t.nav.blog}</span>
          </div>
          <h1 className="h-display text-5xl md:text-6xl mb-6">{t.blog.title}</h1>
          <p className="text-dim text-lg leading-relaxed">{t.blog.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((p, i) => (
            <article key={p.id} data-testid={`blog-post-${i}`} className="group">
              <Link to={`/blog/${p.slug}`}>
                <div className="aspect-[4/5] overflow-hidden border border-goldSoft mb-5">
                  <img
                    src={p.cover_image || "https://images.unsplash.com/photo-1603143600562-e765fc279ae8?w=1200"}
                    alt=""
                    className="w-full h-full object-cover img-moody group-hover:scale-105"
                    style={{ transition: "transform 700ms ease" }}
                  />
                </div>
                <span className="eyebrow">{new Date(p.created_at).toLocaleDateString(lang === "el" ? "el-GR" : "en-GB")}</span>
                <h2 className="font-serif text-2xl md:text-3xl mt-2 mb-3 group-hover:text-gold transition-colors">
                  {lang === "el" ? p.title_el : p.title_en}
                </h2>
                <p className="text-dim text-sm leading-relaxed line-clamp-3">{lang === "el" ? p.excerpt_el : p.excerpt_en}</p>
                <span className="inline-flex items-center gap-2 text-gold text-xs uppercase tracking-widest mt-4">
                  {t.blog.read_more} <ArrowRight size={12} />
                </span>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;
